var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSliderLeftBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 12,
    viewBox: "0 0 21 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.2615 1.94164C7.37203 1.83864 7.46068 1.71444 7.52217 1.57645C7.58366 1.43845 7.61672 1.28948 7.61939 1.13842C7.62205 0.987368 7.59427 0.837324 7.53768 0.697242C7.4811 0.557159 7.39689 0.42991 7.29006 0.323082C7.18323 0.216253 7.05598 0.132036 6.9159 0.0754547C6.77581 0.0188723 6.62577 -0.00891495 6.47472 -0.00624943C6.32366 -0.00358391 6.17469 0.029479 6.03669 0.0909672C5.89869 0.152454 5.77449 0.241109 5.6715 0.351639L0.796501 5.22664L0 6.02164L0.795 6.81664L5.67 11.6916C5.88208 11.8967 6.1662 12.0102 6.46118 12.0078C6.75615 12.0054 7.03837 11.8872 7.24706 11.6787C7.45574 11.4702 7.57419 11.1881 7.57689 10.8931C7.57959 10.5981 7.46633 10.3139 7.2615 10.1016L4.3065 7.14664L19.875 7.14664C20.1734 7.14664 20.4595 7.02811 20.6705 6.81713C20.8815 6.60616 21 6.32001 21 6.02164C21 5.72327 20.8815 5.43712 20.6705 5.22614C20.4595 5.01517 20.1734 4.89664 19.875 4.89664L4.3065 4.89664L7.2615 1.94164Z",
    fill: "#949494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderLeftBtn);
export default __webpack_public_path__ + "static/media/slider_left_btn.bf3aa33a404e55c4e6562edb3aec4d08.svg";
export { ForwardRef as ReactComponent };